import { useAuth } from '../contexts/AuthContext';
import { DemandaDetailPage } from './DemandaDetailPage';
import { DemandaDetailSecretario } from './DemandaDetailSecretario';

export function DemandaDetailRouter() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.perfil === 'secretario') return <DemandaDetailSecretario />;
  return <DemandaDetailPage />;
}
